import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";

const PromotionContext = React.createContext({
  state: { companyNews: {} },
  actions: {
    getPromotion: () => {},
  },
});

const PromotionProvider = ({ children }) => {
  const [noticeList, setNoticeList] = useState([]);
  const [notice, setNotice] = useState([]);
  const [companyNewsList, setCompanyNewsList] = useState([]);
  const [disclosureList, setDisclosureList] = useState([]);
  const [disclosure, setDisclosure] = useState({});
  const [tenderList, setTenderList] = useState([]);
  const [tender, setTender] = useState([]);
  const [investChart, setInvestChart] = useState([]);
  const [history, setHistory] = useState([]);
  const [brochureOperationList, setBrochureOperationList] = useState([]);
  const [referenceList, setReferenceList] = useState([]);
  const [reference, setReference] = useState([]);
  const [mediaList, setMediaList] = useState([]);
  const [fund, setFund] = useState([]);
  const [fundList, setFundList] = useState([]);
  const [chartList, setChartList] = useState([])
  const getNoticeList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/notice/list",
      method: "get",
      params: {
        noticeTitle: pageInfo && pageInfo.noticeTitle,
        noticeFlg: pageInfo && pageInfo.noticeFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setNoticeList(res.data);
      } else {
      }
    });
  }, []);

  const getCompanyNewsList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/media/list",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setCompanyNewsList(res.data);
      } else {
      }
    });
  }, []);

  const getDisclosureList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/disclosure/list",
      method: "get",
      params: {
        disclosureTitle: pageInfo && pageInfo.disclosureTitle,
        disclosureCategory: pageInfo && pageInfo.disclosureCategory,
        disclosureFlg: pageInfo && pageInfo.disclosureFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setDisclosureList(res.data);
      } else {
      }
    });
  }, []);



  const getNotice = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/notice",
      method: "get",
      params: {
        noticeId: pageInfo && pageInfo.noticeId,
        noticeTitle: pageInfo && pageInfo.noticeTitle,
        noticeFlg: pageInfo && pageInfo.noticeFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setNotice(res.data);
      } else {
      }
    });
  }, []);

  const getDisclosure = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/disclosure",
      method: "get",
      params: {
        disclosureId: pageInfo && pageInfo.disclosureId,
        disclosureTitle: pageInfo && pageInfo.disclosureTitle,
        disclosureFlg: pageInfo && pageInfo.disclosureFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        
        disclosureCategory: pageInfo && pageInfo.disclosureCategory,
      },
    }).then((res) => {
      if (res.code === 200) {
        setDisclosure(res.data);
      } else {
      }
    });
  }, []);

  const getTenderList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/tender/list",
      method: "get",
      params: {
        tenderNoticeTitle: pageInfo && pageInfo.tenderNoticeTitle,
        tenderNoticeFlg: pageInfo && pageInfo.tenderNoticeFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setTenderList(res.data);
      } else {
      }
    });
  }, []);

  const getTender = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/tender",
      method: "get",
      params: {
        tenderNoticeId: pageInfo && pageInfo.tenderNoticeId,
        tenderNoticeTitle: pageInfo && pageInfo.tenderNoticeTitle,
        tenderNoticeFlg: pageInfo && pageInfo.tenderNoticeFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setTender(res.data);
      } else {
      }
    });
  }, []);

  const getInvestChart = useCallback(() => {
    HttpAction({
      url: "api/member/brochure/invest/chart",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setInvestChart(res.data);
      } else {
      }
    });
  }, []);

  const getHistory = useCallback(() => {
    HttpAction({
      url: "api/member/brochure/history/list",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setHistory(res.data);
      } else {
      }
    });
  }, []);

  const getBrochureOperationList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/brochure/operation/list",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setBrochureOperationList(res.data);
      } else {
      }
    });
  }, []);

  const getReferenceList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/reference/list",
      method: "get",
      params: {
        referenceTitle: pageInfo && pageInfo.referenceTitle,
        referenceFlg: pageInfo && pageInfo.referenceFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setReferenceList(res.data);
      } else {
      }
    });
  }, []);

  const getReference = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/reference",
      method: "get",
      params: {
        referenceTitle: pageInfo && pageInfo.referenceTitle,
        referenceFlg: pageInfo && pageInfo.referenceFlg,
        referenceId: pageInfo && pageInfo.referenceId,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setReference(res.data);
      } else {
      }
    });
  }, []);

  const getMediaList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/media/list",
      method: "get",
      params: {
        mediaInfoTitle: pageInfo && pageInfo.mediaInfoTitle,
        mediaInfoFlg: pageInfo && pageInfo.mediaInfoFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setMediaList(res.data);
      } else {
      }
    });
  }, []);

  const getFund = useCallback((fundCode)=>{
    HttpAction({
      url: "api/member/fund",
      method: "get",
      params: {
        fundCode: fundCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFund(res.data);
      } else {
      }
    });

  },[])

  const getFundList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/fund/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFundList(res.data);
      } else {
      }
    });
  }, []);

  const getChartList = useCallback((fundCode) => {
    HttpAction({
      url: "api/member/fund/price/chart",
      method: "get",
      params: {
        fundCode: fundCode
      },
    }).then((res) => {
      if (res.code === 200) {
        setChartList(res.data);
      } else {
      }
    });
  }, []);

  const value = {
    state: {
      noticeList,
      companyNewsList,
      disclosureList,
      tenderList,
      disclosure,
      tender,
      notice,
      investChart,
      history,
      brochureOperationList,
      referenceList,
      reference,
      mediaList,
      fund,
      fundList,
      chartList
    },
    actions: {
      getNoticeList,
      getCompanyNewsList,
      getNotice,
      getDisclosureList,
      getTenderList,
      getDisclosure,
      getTender,
      getInvestChart,
      getHistory,
      getBrochureOperationList,
      getReferenceList,
      getReference,
      getMediaList,
      getFund,
      getFundList,
      getChartList
    },
  };

  return (
    <PromotionContext.Provider value={value}>
      {children}
    </PromotionContext.Provider>
  );
};

const { Consumer: PromotionConsumer } = PromotionContext;

export { PromotionProvider, PromotionConsumer, PromotionContext };

export default PromotionContext;
